'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Styles = require('./TargetDateSeriesPartnerLogos.css');

var TargetDateSeriesPartnerLogos = (_dec = (0, _reactCssModules2.default)(Styles, { allowMultiple: true }), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(TargetDateSeriesPartnerLogos, _Component);

  function TargetDateSeriesPartnerLogos(props) {
    (0, _classCallCheck3.default)(this, TargetDateSeriesPartnerLogos);
    return (0, _possibleConstructorReturn3.default)(this, (TargetDateSeriesPartnerLogos.__proto__ || (0, _getPrototypeOf2.default)(TargetDateSeriesPartnerLogos)).call(this, props));
  }

  (0, _createClass3.default)(TargetDateSeriesPartnerLogos, [{
    key: 'render',
    value: function render() {
      var iyvCode = this.props.iyvCode;


      var partnerLogos = null;
      var partnerTagline = null;
      switch (iyvCode) {
        case 'fff':
          partnerLogos = [[require('../../../static/images/partnerlogos/FFIS.png'), 'FFF Solutions'], [require('../../../static/images/partnerlogos/macroclimate_logo_wide.png'), 'Macroclimate'], [require('../../../static/images/partnerlogos/urgewald.png'), 'Urgewald Global Coal Exit List']];
          partnerTagline = 'Company research provided by';
          break;

        case 'ffb':
          partnerLogos = [[require('../../../static/images/partnerlogos/banking-on-climate-chaos.jpg'), 'Banking on Climate Chaos coalition', 1]];
          partnerTagline = 'Company research provided by';
          break;

        case 'ffi':
          partnerLogos = [[require('../../../static/images/partnerlogos/iof-logo.png'), 'Insure our Future']];
          partnerTagline = 'Company research provided by';
          break;

        case 'dff':
          partnerLogos = [[require('../../../static/images/partnerlogos/FOE_logo.png'), 'Friends of the Earth U.S.']];
          partnerTagline = 'Deforestation Free Funds is a partnership with';
          break;

        case 'gef':
          partnerLogos = [[require('../../../static/images/partnerlogos/equileap-logo.png'), 'Equileap']];
          partnerTagline = 'Company research provided by';
          break;

        // case 'gff':
        //   break

        case 'pff':
          partnerLogos = [[require('../../../static/images/partnerlogos/AFSC-logo.jpg'), 'American Friends Service Committee']];
          partnerTagline = 'Company research sourced from';
          break;

        case 'wff':
          partnerLogos = [[require('../../../static/images/partnerlogos/SIPRI_small.png'), 'Stockholm International Peace Research Institute'], [require('../../../static/images/partnerlogos/PAX_Logo_EN_WithSlogan_WEB_FC.png'), 'PAX']];
          partnerTagline = 'Company research sourced from';
          break;

        case 'tff':
          partnerLogos = [[require('../../../static/images/partnerlogos/ucsf-tobacco-logo.png'), 'UCSF Center for Tobacco Control Research and Education'], [require('../../../static/images/partnerlogos/ucsf-smokefreemovies-logo.png'), 'UCSF Smoke Free Movies Campaign']];
          partnerTagline = 'Company research sourced from';
          break;
      }

      if (!partnerLogos || !partnerTagline) {
        return null;
      }

      //
      return _react2.default.createElement(
        'div',
        { styleName: 'partners-wrap' },
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'div',
            null,
            partnerTagline
          ),
          partnerLogos.length > 0 ? _react2.default.createElement(
            'div',
            { styleName: 'partner-logo-img-flex' },
            partnerLogos.map(function (e, i) {
              return _react2.default.createElement('img', {
                key: 'partner-logo-' + i,
                src: e[0],
                alt: e[1],
                styleName: e[2] ? 'partner-logo-img-lg' : 'partner-logo-img'
              });
            })
          ) : null
        )
      );
    }
  }]);
  return TargetDateSeriesPartnerLogos;
}(_react.Component), _class2.propTypes = {
  // three letters, fff/dff/gef/gff/pff/wff/tff
  iyvCode: _react.PropTypes.string.isRequired
}, _temp)) || _class);
exports.default = TargetDateSeriesPartnerLogos;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/TargetDateSeriesPartnerLogos/TargetDateSeriesPartnerLogos.js
// module id = 1454
// module chunks = 0